export default [
  {
    name: 'CMU',
    path: 'cmu',
    component: () => import('@/views/parametrosComCa/cmu/Index.vue'),
    meta: {
      requiresAuth: true,
      breadcrumb: [{ name: 'Dados', path: '/dados' }, { name: 'CMU' }]
    }
  },
  {
    name: 'CMU Adicionar',
    path: 'cmu/edit',
    component: () => import('@/views/parametrosComCa/cmu/Edit.vue'),
    meta: {
      requiresAuth: true,
      breadcrumb: [{ name: 'Dados', path: '/dados' }, { name: 'CMU', path: '/parametros-com-ca/cmu' }, { name: 'Adicionar' }]
    }
  },
  {
    name: 'CMU Editar',
    path: 'cmu/edit/:id',
    component: () => import('@/views/parametrosComCa/cmu/Edit.vue'),
    meta: {
      requiresAuth: true,
      admin: true,
      breadcrumb: [{ name: 'Dados', path: '/dados' }, { name: 'CMU', path: '/parametros-com-ca/cmu' }, { name: 'Editar' }]
    }
  }
];
